<!-- 图片分类 -->
<template>
  <div class="category-management">
    <page-title title="筛选">
      <el-row class="category-management__filter-header" :gutter="20">
        <el-col :xl="4" :span="6">
          <span>分类名称：</span>
          <el-input v-model="filter.name" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="2" :span="4">
          <el-checkbox :false-label="0" :true-label="1" v-model="filter.isHome"
            >只看首页推荐</el-checkbox
          >
        </el-col>
        <el-col :xl="2" :span="4">
          <el-checkbox
            :false-label="0"
            :true-label="1"
            v-model="filter.isPicture"
            >只看图片页推荐</el-checkbox
          >
        </el-col>
        <el-col :xl="3" :span="6">
          <el-button @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
          <el-button @click="openDialog('add')">新增</el-button>
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div class="category-management__body">
        <el-radio-group
          style="margin-bottom: 20px;"
          v-model="currentType"
          size="small"
          @change="search"
        >
          <el-radio-button
            v-for="item in typeItems"
            :key="item.value"
            :label="item.value"
          >
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="100"
          ></el-table-column>
          <el-table-column prop="name" label="分类名称"></el-table-column>
          <el-table-column label="首页推荐" v-if="currentType == 1">
            <template slot-scope="scope">
              <el-switch
                @change="handleSwitchChange(scope.row, 1)"
                :active-value="1"
                :inactive-value="0"
                active-color="#005bff"
                inactive-color="#dadde0"
                v-model="scope.row.isHome"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="图片页推荐" v-if="currentType == 1">
            <template slot-scope="scope">
              <el-switch
                @change="handleSwitchChange(scope.row, 2)"
                :active-value="1"
                :inactive-value="0"
                active-color="#005bff"
                inactive-color="#dadde0"
                v-model="scope.row.isPicture"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column
            prop="sort"
            sortable
            label="排序"
            width="80"
          ></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <!--  -->
              <!-- {{ tableData[0].id }}
                            {{ scope.row.id }} -->
              <el-button
                class="edit"
                type="text"
                @click="openDialog('edit', scope.row)"
                >编辑</el-button
              >
              <el-button
                :disabled="scope.$index == 0"
                class="edit"
                type="text"
                @click="move('up', scope.row)"
                >上移</el-button
              >
              <el-button
                :disabled="scope.$index == tableData.length - 1"
                class="edit"
                type="text"
                @click="move('down', scope.row)"
                >下移</el-button
              >
              <el-button class="edit" type="text" @click="deleteRow(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination
          :total="total"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          @size-change="getList"
        ></cus-pagination>
      </div>
    </page-title>
    <!-- 新增 编辑 弹窗 -->
    <category-dialog
      :title="dialogMode === 'add' ? '新增分类' : '编辑分类'"
      :showType="0"
      :visible.sync="dialogVisible"
      :data="currentData"
      :mode="dialogMode"
      @confirm="handleConfirm"
      :loading="apiEnd"
    ></category-dialog>
  </div>
</template>

<script>
import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import {
  getCategoryPageList,
  categoryAdd,
  categoryEdit,
  upAndDown,
  categoryDel,
} from "@/api/page";
import CategoryDialog from "./components/CategoryDialog.vue";
import { Message } from "element-ui";
import { scope } from "@/config/config";
export default {
  components: {
    PageTitle,
    CusPagination,
    CategoryDialog,
  },
  data() {
    return {
      apiEnd: false,
      loading: true,
      filter: {
        name: "",
        isHome: null,
        isPicture: null,
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogMode: "add", // 默认模式
      currentData: {}, // 当前表单数据

      //v4.2
      currentType: 1,
      typeItems: [
        {
          label: "图片",
          value: 1,
        },
        {
          label: "音频",
          value: 2,
        },
        {
          label: "视频",
          value: 3,
        },
        {
          label: "知识库",
          value: 4,
        },
      ],
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  methods: {
    async getList() {
      this.loading = true;
      const params = {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        name: this.filter.name, // name 字段始终传递
        mealType: this.currentType,
      };

      // 只有值为1时才添加对应字段
      if (this.filter.isHome === 1) {
        params.isHome = this.filter.isHome;
      }
      if (this.filter.isPicture === 1) {
        params.isPicture = this.filter.isPicture;
      }

      const { data } = await this.$ajax.get(getCategoryPageList, params);
      this.tableData = data?.data?.records || [];
      this.total = data?.data?.total || 0;
      this.loading = false;
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    reset() {
      this.filter.name = "";
      this.filter.isHome = null;
      this.filter.isPicture = null;
      this.getList();
    },
    edit(row) {
      console.log("Editing row", row);
    },
    async delApi(id) {
      const res = await this.$ajax.delete(categoryDel(id));
      const { code, msg } = res?.data ?? {};
      console.log(code);
      if (code == 200) {
        Message.success(msg);
        this.getList();
      }
    },
    /**
     * 删除
     */
    deleteRow(row) {
      if (row.isPicture || row.isHome == 1) {
        Message.warning("开启推荐的图片不允许删除");
        return;
      }
      this.$confirm("确认删除该项吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.delApi(row.id);
        })
        .catch(() => {
          Message.info("删除已取消");
        });
    },
    handlePageChange(page) {
      console.log("Page changed to", page);
    },
    openDialog(mode, data = {}) {
      this.dialogMode = mode;
      this.currentData = { ...data };
      this.dialogVisible = true;
    },
    /**
     * 新增接口
     */
    async addApi(params) {
      this.apiEnd = true;
      try {
        const { data } = await this.$ajax.post(categoryAdd, params);
        if (data.code === 200) {
          this.apiEnd = false;
          this.dialogVisible = false;
          this.getList();
          Message.success(data.msg);
        } else if (data.code === 500) {
          this.$message.error(data.msg);
          this.apiEnd = false;
        }
      } finally {
        this.apiEnd = false;
      }
    },
    /**
     * 编辑接口
     */
    async editApi(params, row) {
      this.apiEnd = true;
      const { data } = await this.$ajax.put(categoryEdit, params);
      if (data.code === 200) {
        this.apiEnd = false;
        this.dialogVisible = false;
        this.getList();
        Message.success(data.msg);
      } else if (data.code === 500) {
        this.$message.error(data.msg);
        this.apiEnd = false;
        if (row) {
          //编辑失败时，将状态还原  开关状态
          row.isHome = !row.isHome;
        }
      }
    },
    handleSwitchChange(row, index) {
      const { id, isHome, isPicture, mealType } = row;
      const params = {
        id,
        isHome,
        mealType,
      };
      const params2 = {
        id,
        isPicture,
        mealType,
      };
      this.editApi(index === 1 ? params : params2, row);
    },
    /**
     * 上移下移
     */
    async upAndDownApi(data) {
      const { data: res } = await this.$ajax.get(upAndDown, data);
      if (res.code === 200) {
        this.getList();
      }
    },
    /**
     * 移动
     */
    move(type, row) {
      const { id } = row;
      const currentIndex = this.tableData.findIndex((item) => item.id === id);
      let targetSort;

      if (type === "up" && currentIndex > 0) {
        targetSort = this.tableData[currentIndex - 1].sort;
      } else if (type === "down" && currentIndex < this.tableData.length - 1) {
        targetSort = this.tableData[currentIndex + 1].sort;
      }

      this.upAndDownApi({ id, sort: targetSort });
    },
    handleConfirm(formData) {
      formData.name = formData.name.replace(/\s+/g, "");
      let that = this;
      if (this.dialogMode === "add") {
        that.addApi(formData);
      } else {
        that.editApi(formData);
        console.log("编辑数据:", formData);
      }
    },
  },
  created() {
    const { query } = this.$route;
    if (JSON.stringify(query) !== "{}") {
      this.filter = Object.assign(this.filter, query);
    }
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.category-management {
  ::v-deep .el-radio-button.is-active .el-radio-button__inner {
    background-color: #002b9c;
    border-color: #002b9c;
  }
  .box-card {
    margin-bottom: 20px;
  }

  &__filter-header {
    display: flex;
    align-items: center;
  }

  &__body {
    .edit {
      color: #005bff;
    }

    .el-button.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }

    .el-switch__label {
      color: #333333;
    }

    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
  }
}
</style>
